var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "category-selection"
  }, [_vm.assetType(_vm.configs.categoryBackground) === 'image' ? _c('img', {
    staticClass: "category-selection__background",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.configs.categoryBackground)
    }
  }) : _vm._e(), _vm.assetType(_vm.configs.categoryBackground) === 'video' ? _c('video', {
    staticClass: "category-selection__background",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.configs.categoryBackground),
      "autoplay": "",
      "muted": "",
      "disablePictureInPicture": "",
      "loop": "",
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    },
    domProps: {
      "muted": true
    }
  }) : _vm._e(), _c('div', {
    staticClass: "category-selection__container"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "category-selection__categories"
  }, _vm._l(_vm.categories, function (category) {
    return _c('div', {
      key: category._id,
      staticClass: "category-selection__category touch",
      on: {
        "click": function click($event) {
          return _vm.navigateToCategory(category);
        }
      }
    }, [_c('div', {
      staticClass: "category-selection__category-inner"
    }, [category.buttonBackground ? _c('div', {
      staticClass: "category-selection__bg"
    }, [_c('img', {
      attrs: {
        "src": "".concat(_vm.$store.state.assetsPath).concat(category.buttonBackground.asset.path)
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "category-selection__label",
      domProps: {
        "innerHTML": _vm._s(category.label[_vm.language.code])
      }
    })])]);
  }), 0), _vm._m(2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "category-selection__map"
  }, [_c('img', {
    attrs: {
      "src": "/assets/region-centred-map.png",
      "alt": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "category-selection__welcome"
  }, [_c('h1', {
    staticClass: "welcome-text"
  }, [_vm._v("Explore the regions of South Australia")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "category-selection__touch-prompt"
  }, [_c('img', {
    attrs: {
      "src": "/assets/touch-prompt.png"
    }
  })]);

}]

export { render, staticRenderFns }